import { MARQUEE_ITEMS } from "../data/site";

const Row = ({ hidden }) => (
  <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
    {MARQUEE_ITEMS.map((item) => (
      <span
        key={item + (hidden ? "-b" : "-a")}
        className="flex items-center font-mono text-xs font-bold uppercase tracking-[0.25em] text-bumbu-bright sm:text-sm"
      >
        <span className="px-6">{item}</span>
        <span className="text-bawang">•</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="menu-marquee" className="overflow-hidden border-y border-amber-900/20 bg-charcoal py-3.5">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row hidden />
    </div>
  </div>
);
